import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.869 15.625a.626.626 0 0 1-1.252 0v-8.75a.626.626 0 0 1 1.252 0Zm3.757 0a.626.626 0 0 1-1.252 0v-8.75a.626.626 0 0 1 1.252 0Zm3.757 0a.626.626 0 0 1-1.252 0v-8.75a.626.626 0 0 1 1.252 0ZM13.369.881 14.418 2.5h3.722a.625.625 0 1 1 0 1.25h-.626v13.125A3.127 3.127 0 0 1 14.383 20H5.616a3.13 3.13 0 0 1-3.131-3.125V3.75H1.86a.625.625 0 1 1 0-1.25h3.721L6.599.881A1.88 1.88 0 0 1 8.188 0h3.624a1.78 1.78 0 0 1 1.557.881M7.061 2.5h5.878l-.6-.956a.62.62 0 0 0-.528-.294H8.188a.62.62 0 0 0-.528.294ZM3.738 16.875a1.877 1.877 0 0 0 1.878 1.875h8.766a1.877 1.877 0 0 0 1.878-1.875V3.75H3.738Z"
    }, null, -1)
  ])))
}
export default { render: render }